<template>
  <div class="list">
    <div class="head">
      <div class="total">共{{length}}个评测</div>
      <div class="sort">
        <span :class="{'active':active==1}" @click="compareByCount(1)">最新</span> |
        <span :class="{'active':active==2}" @click="compareByCount(2)">最热</span> |
        <span :class="{'active':active==3}" @click="compareByCount(3)">价格</span>
      </div>
    </div>

    <div class="list-wrap">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :immediate-check="false" offset="50">
        <div class="list-item" v-for="(item,index) in cateList" :key="index" @click="toDetail(item)">
          <van-image width="90" height="90" fit="cover" :src="publicUrl + item.quizThumbnail" />
          <div class="item-info">
            <h3 class="van-ellipsis">{{item.quizName}}</h3>
            <p class="van-ellipsis" style="line-height:4vh;">{{item.quizIntro}}</p>
            <div class="item-bottom">
              <div class="user-count">{{handleUserCount (item.userCount)}}人已测</div>
              <div class="price">¥{{item.h5SalePrice}}</div>
            </div>
          </div>
        </div>
      </van-list>
    </div>

  </div>
</template>

<script>
import * as api from "@p/api";
import publicUrl from "@p/public";
import VanImage from "@m/vant/Image";
import List from "@m/vant/List";
import Tab from "@m/vant/Tab";
import { handleUserCount } from "@p/util.js";
export default {
  mixins: [VanImage, List, Tab],
  data() {
    return {
      publicUrl,
      cateList: [],
      length: 0,
      loading: false,
      finished: false,
      active: "",
      allData: [],
      pageSize: 10
    };
  },
  created() {
    this.getQuizList();
  },

  props: {
    cateId: {
      type: Number
    }
  },
  watch: {
    cateId(val) {
      console.log("新的", val);
      this.getQuizList();
    }
  },
  methods: {
    handleUserCount,
    onLoad() {
      // 异步更新数据
      this.lazyLoad();
    },
    lazyLoad() {
      setTimeout(() => {
        for (let i = 10; i < this.length; i++) {
          this.cateList.push(this.allData[i]);
        }
        this.loading = false;
        if (this.cateList.length >= this.length) {
          this.finished = true;
        }
      }, 1000);
    },
    async getQuizList() {
      var cateId = this.cateId;
      var res = await api.requestApiByGet("quizList", cateId);
      console.log("分类列表", res);
      if (res.code === 0) {
        this.allData = res.data;
        console.log(this.allData);
        this.length = res.data.length;
        this.cateList = [];
        if (this.length === 0) {
          return false;
        } else if (this.pageSize > this.length) {
          for (let i = 0; i < this.length; i++) {
            this.cateList.push(this.allData[i]);
          }
          console.log(this.cateList);
          this.loading = false;
        } else {
          for (let i = 0; i < this.pageSize; i++) {
            this.cateList.push(this.allData[i]);
          }
          console.log(this.cateList);
          this.loading = false;
          if (this.cateList.length >= this.length) {
            this.finished = true;
          }
        }
      }
    },
    compareByCount(index) {
      if (index === 3) {
        this.active = 3;
        this.cateList.sort((a, b) => b.userCount - a.userCount);
      } else if (index === 2) {
        this.active = 2;
        this.cateList.sort((a, b) => b.userCount - a.userCount);
      } else if (index === 1) {
        this.active = 1;
        this.cateList.sort(
          (a, b) =>
            Date.parse(b.createTime.replace(/-/g, "/")) -
            Date.parse(a.createTime.replace(/-/g, "/"))
        );
      }
      // else if (index === 1) {
      //   return arr.sort(
      //     (a, b) =>
      //       Date.parse(b.key.replace(/-/g, "/")) -
      //       Date.parse(a.key.replace(/-/g, "/"))
      //   );
      // }
    },
    toDetail(item) {
      this.$emit('todetail', item.id)
    }
  }
};
</script>

<style lang="less" scoped>
.active {
  color: @primary!important;
  font-weight: 900;
}
.list {
  height: 100%;
  overflow: hidden;
  .head {
    // width: calc(100% - 105px);
    // position: absolute;
    // top: 0;
    // left: 95px;
    padding: 14px 10px 20px 10px;
    z-index: 999;
    background: #fff;
    display: flex;
    justify-content: space-between;
    .total {
      color: @gray-6;
      font-size: @font-size-md;
    }
    .sort {
      span {
        color: @gray-6;
        font-size: @font-size-lg;
      }
    }
  }
  .list-wrap::-webkit-scrollbar {
    width: 0;
    height: 0;
    opacity: 0;
    display: hidden !important;
  }
  .list-wrap {
    height: calc(100% - 50px);
    overflow: auto;

    .van-list::-webkit-scrollbar {
      display: hidden !important;
    }

    .list-item {
      display: flex;
      margin: 0 8px 4vh 8px;
      /deep/.van-image {
        flex: none;
        img {
          border-radius: 4px;
        }
      }
      .item-info {
        flex: 1;
        width: calc(100% - 120px);
        margin: 0 0 0 10px;
        position: relative;
        > h3 {
          line-height: 1.5;
          color: @gray-8;
          font-size: @font-size-lg;
          font-weight: @font-weight-bold;
        }
        p {
          color: @gray-6;
          font-size: @font-size-sm;
        }
        .item-bottom {
          position: absolute;
          bottom: 0px;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .user-count {
            color: @gray-6;
            font-size: @font-size-sm;
          }
          .price {
            width: 20px;
            text-align: center;
            font-weight: @font-weight-bold;
            font-size: @font-size-md;
            border-radius: 10px;
            padding: 5px 20px;
            color: @orange;
            background: #fff5ee;
          }
        }
      }
    }
  }
}
.list::-webkit-scrollbar {
  display: none !important;
}
</style>
